import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-connectors",
  class: "width-100 height-100 d-flex flex-fill"
}
const _hoisted_2 = { class: "d-flex flex-row width-100 height-100 padding-8" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-start logo-cell-116" }
const _hoisted_4 = { class: "img-box-white d-flex align-items-center justify-content-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_7 = { class: "pagination-wrapper mt-1" }
const _hoisted_8 = {
  key: 0,
  class: "card border-0 background-fb"
}
const _hoisted_9 = { class: "edit-header d-flex flex-row justify-content-between align-items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "d-flex flex-row align-items-center" }
const _hoisted_12 = { class: "margin-0" }
const _hoisted_13 = { class: "margin-0" }
const _hoisted_14 = { class: "card-body d-flex flex-column overflow-auto" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "loader-div-sm"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "loader-div-40" }
const _hoisted_19 = ["src"]

import { ElCard, ElInput, ElTable, ElTableColumn } from "element-plus";
import { onMounted, ref } from "vue";
import { getConnectorListing } from "@/connector/services/connector.service";
import i18n from "@/core/i18n/i18n";
import { getActionSummaries } from "@/flow/services/connectorAction.service";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { updateMultiplePreference, updateSinglePreference } from "@/core/auth";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Connectors',
  setup(__props) {

const { t } = i18n.global;
const connectorList = ref([]);
const loadingConnectors = ref(false);
const connectorsRequestGuard = useLatestRequestGuard();

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "15px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
});

const actionsVisible = ref(false);

const actions = ref([]);

const actionsLoading = ref(false);

const actionsId = ref("");

const selectedSpecId = ref("");

const search = ref("");

const sortField = ref(
  getPreferenceValue("connectorsSortField")
    ? getPreferenceValue("connectorsSortField")
    : "name"
);

const sortAscending = ref(
  getPreferenceValue("connectorsSortOrder")
    ? getPreferenceValue("connectorsSortOrder")
    : "ascending"
);

const hoverId = ref("");

const perPageConnectors = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);

const currentPageConnectors = ref(1);

const numberOfConnectors = ref(0);

function cellMouseEnter(row) {
  hoverId.value = row.id;
}

function cellMouseLeave() {
  hoverId.value = "";
}

function sizeChanged(val) {
  perPageConnectors.value = val;
  updateSinglePreference("pageSize", val);
  getConnectors();
}

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    connectorsSortField: sort.prop,
    connectorsSortOrder: sort.order,
  });
  getConnectors();
}

const { onSearchInput } = useDebouncedSearch(getConnectors);

function checkLength(length) {
  return length < 2;
}

async function getConnectors() {
  const requestToken = connectorsRequestGuard.start();
  loadingConnectors.value = true;
  const params = {
    pageNumber: currentPageConnectors.value - 1,
    pageSize: perPageConnectors.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
    search: search.value,
  };
  try {
    const page = await getConnectorListing(params);
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!connectorsRequestGuard.isLatest(requestToken)) {
      return;
    }
    connectorList.value = page.data;
    numberOfConnectors.value = page.totalElements;
  } finally {
    // OT-4928: only the newest request owns the spinner — a superseded one must
    // not clear it, and a newest one that fails must not leave it stuck on.
    if (connectorsRequestGuard.isLatest(requestToken)) {
      loadingConnectors.value = false;
    }
  }
}

function showActions(connector) {
  if (actionsId.value === connector.id && actionsVisible.value) {
    actionsVisible.value = false;
    actionsId.value = "";
    actions.value = [];
    selectedSpecId.value = "";
  } else {
    actionsId.value = connector.id;
    actionsLoading.value = true;
    actionsVisible.value = true;
    selectedSpecId.value = connector.connectorSpecId;
    // This panel renders a count and a list of descriptions, so the summary endpoint is all it
    // needs. The full-document endpoint it used to call returns up to 14MB for one connector.
    getActionSummaries(connector.connectorSpecId).then((response) => {
      if (response) {
        actions.value = response;
      }
      actionsLoading.value = false;
    });
  }
}

function closeActionsTab() {
  actionsVisible.value = false;
  actionsId.value = "";
  actions.value = [];
  selectedSpecId.value = "";
}

onMounted(() => {
  getConnectors();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElCard), { class: "card border-0 oneTeg-card oneTeg-card-body" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: connectorList.value,
            "empty-text": loadingConnectors.value ? ' ' : 'No Data',
            onCellMouseEnter: cellMouseEnter,
            onCellMouseLeave: cellMouseLeave,
            onSortChange: sortChanged,
            "table-layout": "auto",
            onRowClick: showActions,
            "row-class-name": 'oneTeg-table-row-permission',
            "default-sort": { prop: sortField.value, order: sortAscending.value },
            class: "oneTeg-table",
            height: "97%"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.Connector'),
                prop: "name",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        class: "logo-step-header",
                        src: `${_unref(ASSETS_BASE_URL)}/${
                      scope.row.connectorSpecId
                    }${_unref(getResolution)(true)}.png`,
                        alt: "logo"
                      }, null, 8, _hoisted_5)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.Description'),
                sortable: "custom",
                prop: "description",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.description), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                prop: "actions",
                width: "260px"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ElInput), {
                      id: "search-input",
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      size: "mini",
                      class: "oneTeg-search-input max-w-170",
                      onInput: _unref(onSearchInput),
                      placeholder: _unref(t)('Common.TypeToSearch')
                    }, null, 8, ["modelValue", "onInput", "placeholder"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "empty-text", "default-sort"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(OneTegPagination, {
              background: true,
              small: true,
              "page-sizes": [10, 25, 50, 100],
              "page-size": perPageConnectors.value,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((perPageConnectors).value = $event)),
              total: numberOfConnectors.value,
              "current-page": currentPageConnectors.value,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPageConnectors).value = $event)),
              onSizeChange: sizeChanged,
              onCurrentChange: getConnectors,
              layout: 'total, sizes, prev, pager, next'
            }, null, 8, ["page-size", "total", "current-page"])
          ])
        ]),
        _: 1
      }),
      (actionsVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["oneteg-drawer-25 margin-left-10 drawer-edge-corner", { 'oneteg-drawer-visible': actionsVisible.value }])
          }, [
            (!actionsLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "logo-l",
                      src: `${_unref(ASSETS_BASE_URL)}/${selectedSpecId.value}${_unref(getResolution)(
                false
              )}.png`,
                      alt: "logo"
                    }, null, 8, _hoisted_10),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h1", _hoisted_12, _toDisplayString(actions.value.length), 1),
                      _createElementVNode("h6", _hoisted_13, "  " + _toDisplayString(checkLength(actions.value.length)
                    ? _unref(t)("Common.Action")
                    : _unref(t)("Common.Actions")), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link",
                      id: "flow-close-step",
                      onClick: closeActionsTab
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "times" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "font-size-14 color-dark-gray",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                          class: "margin-right-10 logo-s",
                          alt: "logo"
                        }, null, 8, _hoisted_15),
                        _createTextVNode(" " + _toDisplayString(action.actionSpec.description), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                    alt: "Loading...",
                    class: "loader-logo-40"
                  }, null, 8, _hoisted_17)
                ]))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_19)
    ], 512), [
      [_vShow, loadingConnectors.value]
    ])
  ]))
}
}

})